export class HoverAccessibleView {
}
export class HoverAccessibilityHelp {
}
export class ExtHoverAccessibleView {
}
//# sourceMappingURL=hoverAccessibleViews.js.map